<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Ereignisse filtern"}}</h4>
	</div>
</div>
<div class="row">
	<div class="col-lg-12">
		<div id="js-filter-bar" class="card-box clearfix">
			<div class="row">
				<div class="col-md-4">
					<label>{{TR "Zeitraum"}}</label><br>
					<input id="js-datepicker" class="form-control input-daterange-timepicker input-sm css-time-range" type="time-range" name="from"></input>
					{{#SELECT timeInterval}}
						<select id="js-predefined-timerange" class="selectpicker dropdown-width-100" data-style="btn btn-sm btn-white" data-empty="{{TR "Bitte wählen Sie einen Zeitraum aus"}}">
							{{#each periods}}
								<option value="{{value}}">{{name}}</option>
							{{/each}}
						</select>
					{{/SELECT}}
				</div>
				<div class="col-md-3">
					<label>{{TR "Ereignisse"}}</label><br>
					{{#SELECT filter}}
						<select id="js-event-filter" class="selectpicker" title="{{title}}" multiple="multiple" data-style="btn-white btn-sm">
							{{#each options}}
								<option data-icon="{{icon}}" value="{{value}}">{{name}}</option>
							{{/each}}
						</select>
					{{/SELECT}}
				</div>
			</div>
		</div>
	</div>
</div>
{{#COMPARE eventCount '>' 0}}
<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Ereignisliste"}} ({{eventCount}})</h4>
	</div>
</div>
<div class="row">
	<div class="col-lg-12">
		<div class="card-box clearfix">
			<div class="row m-b-30">
				<div class="col-xs-12">
					<div id="js-pagination"></div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<div id="js-event-log" class="timeline-2 m-l-10">
						{{{eventLog}}}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
{{else}}
<div class="row">
	<div class="col-lg-12">
		<div class="card-box clearfix">
			{{#COMPARE eventCount '==' 0}}
			<h3>{{TR "Keine Ereignisse gefunden"}}</h3>
			{{else}}
			{{TR "Ereignisse werden geladen."}} <i class="fa fa-spin fa-spinner"></i>
			{{/COMPARE}}
		</div>
	</div>
</div>
{{/COMPARE}}
